
namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    export class GraphGrid extends Serenity.EntityGrid<GraphRow, any> {
        protected getColumnsKey() { return 'Visualizer.Graph'; }
        protected getDialogType() { return GraphDialog; }
        protected getIdProperty() { return GraphRow.idProperty; }
        protected getLocalTextPrefix() { return GraphRow.localTextPrefix; }
        protected getService() { return GraphService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}